export default "__VITE_ASSET__CiavFVC___"